export const translations = {
  fr: {
    nav: {
      brandSub: "& Consulting",
      expertises: "Expertises",
      references: "Références",
      method: "Méthode",
      insights: "Insights",
      about: "À propos",
      contact: "Contact",
      cta: "Prendre rendez-vous",
      menu: "Menu",
    },
    hero: {
      badge: "Vision • Stratégie • Transformation • Exécution",
      titleA: "Aligner Vision, Transformation et Exécution pour ",
      titleHighlight: "créer de la valeur",
      titleEnd: ".",
      subtitle:
        "Birrou Advisory & Consulting accompagne les gouvernements, institutions, opérateurs et entreprises dans leurs projets stratégiques, leurs transformations organisationnelles et technologiques, ainsi que dans le pilotage d'initiatives complexes créatrices de valeur durable.",
      micro:
        "17+ ans d'expérience sur des programmes stratégiques chez Orange, Orange Cyberdéfense et Orange Innovation — Europe, Afrique et Moyen-Orient.",
      ctaWhatsapp: "Prendre rendez-vous",
      ctaExpertises: "Découvrir mes expertises",
      ctaLinkedin: "Voir le profil LinkedIn",
      proofs: [
        { value: "17+", label: "ans d'expérience" },
        { value: "x3", label: "capacité de livraison" },
        { value: "2M€", label: "économies cloud" },
        { value: "300M€+", label: "programme IRIS²" },
        { value: "", label: "Europe • Afrique • MENA" },
      ],
    },
    value: {
      overline: "Proposition de valeur",
      title: "Une expertise stratégique ancrée dans l'exécution.",
      paragraph:
        "Dans les transformations complexes, le défi n'est pas seulement de définir une vision. Le vrai enjeu est d'aligner les acteurs, de prioriser les actions, de piloter l'exécution et de produire des résultats mesurables.",
      quote:
        "« Je ne viens pas avec des solutions toutes faites. Je commence par comprendre les enjeux, les contraintes et les priorités, puis je co-construis une trajectoire réaliste, viable et exécutable. »",
      dimensions: [
        { title: "Stratégie", desc: "Définir une vision claire, des priorités lisibles et des arbitrages soutenables." },
        { title: "Transformation", desc: "Aligner les acteurs, structurer la gouvernance et orchestrer le changement." },
        { title: "Technologie", desc: "Architecturer des solutions modernes, souveraines et durables." },
        { title: "Exécution", desc: "Piloter la livraison, mesurer la valeur, sécuriser les résultats." },
      ],
    },
    expertises: {
      overline: "Expertises",
      title: "Cinq domaines, une exigence : transformer pour de bon.",
      paragraph:
        "Des expertises complémentaires pour structurer, moderniser et piloter vos transformations sur des environnements complexes et multi-acteurs.",
      blocks: [
        {
          title: "Stratégie digitale & gouvernance",
          items: [
            "Stratégie digitale nationale",
            "Gouvernance multi-acteurs",
            "PMO stratégique",
            "Transformation organisationnelle",
            "Interopérabilité",
            "Rationalisation des initiatives numériques",
          ],
        },
        {
          title: "Télécommunications & infrastructures",
          items: [
            "Stratégie télécom nationale",
            "Modernisation des réseaux",
            "4G / 5G / fibre",
            "Modèles PPP",
            "Monétisation des infrastructures",
            "Inclusion numérique",
          ],
        },
        {
          title: "Cloud souverain & cybersécurité",
          items: [
            "Cloud governance",
            "Cloud souverain",
            "FinOps",
            "SOC cloud",
            "DevSecOps",
            "Sécurité-by-design",
          ],
        },
        {
          title: "Transformation IT & opérations",
          items: [
            "Rationalisation IT",
            "Lean-Agile",
            "Gouvernance projets",
            "Automatisation",
            "Industrialisation des déploiements",
            "Capacité de livraison",
          ],
        },
        {
          title: "Innovation, IA & solutions unifiées",
          items: [
            "Product as a Service",
            "Plateformes unifiées",
            "Marketplace IA",
            "Automatisation intelligente",
            "Solutions souveraines",
            "Transformation des usages",
          ],
        },
      ],
    },
    cases: {
      overline: "Références",
      title: "Des références solides dans des environnements complexes.",
      labels: { context: "Contexte", actions: "Actions", results: "Résultats" },
      list: [
        {
          tag: "Orange Cyberdéfense",
          title: "Accélérer la livraison des services cybersécurité dans un contexte de forte croissance",
          context:
            "Forte croissance business, priorités changeantes, fusion d'équipes, ressources limitées et exigences fortes de sécurité.",
          actions: [
            "Alignement business / IT / opérations",
            "Gouvernance Lean-Agile",
            "Priorisation des backlogs",
            "Industrialisation des déploiements",
            "Simplification des processus",
          ],
          results: [
            "Capacité de livraison multipliée par 3",
            "Passage de 2 à 6 projets livrés en 3 mois",
            "Satisfaction client en hausse",
            "Pression sur les équipes réduite",
          ],
          metric: { value: "x3", label: "capacité de livraison" },
        },
        {
          tag: "IRIS²",
          title: "Piloter des offres souveraines dans un programme spatial européen stratégique",
          context:
            "Programme européen de communications souveraines et sécurisées, environnement multi-partenaires, logique coopération / compétition.",
          actions: [
            "Pilotage de deux lots stratégiques",
            "Coordination de 5 work packages",
            "Offres techniques, financières, contractuelles & sécurité",
            "Challenge fournisseurs",
            "Optimisation coûts / risques / performance",
          ],
          results: [
            "Offre complète livrée dans les délais",
            "Félicitations du consortium",
            "Crédibilité Orange renforcée",
            "Meilleure compétitivité technique et financière",
          ],
          metric: { value: "300M€+", label: "programme stratégique" },
        },
        {
          tag: "Cloud Operations",
          title: "Structurer un modèle opérationnel cloud sécurisé, efficient et rentable",
          context:
            "Cloudification d'Orange Innovation, enjeux de sécurité, coûts, souveraineté et gouvernance multi-entités.",
          actions: [
            "Gouvernance cloud transverse",
            "Mise en place FinOps",
            "Déploiement SOC cloud",
            "Coordination hyperscalers",
            "Rationalisation des usages",
          ],
          results: [
            "2 M€ d'économies sur 18 M€ de dépenses cloud",
            "88 règles de sécurité monitorées",
            "Visibilité financière améliorée",
            "Gouvernance cloud renforcée",
          ],
          metric: { value: "2M€", label: "économies cloud" },
        },
        {
          tag: "Telco Cloud — Filiale européenne",
          title: "Accélérer la transformation Telco Cloud d'une filiale européenne d'Orange",
          context:
            "Transformation stratégique vers la virtualisation, l'automatisation et la préparation 5G.",
          actions: [
            "Alignement équipes pays / Groupe",
            "Pilotage des arbitrages techniques",
            "Coordination fournisseurs",
            "Architecture WAN/CNF bout-en-bout",
            "Animation des comités de pilotage",
          ],
          results: [
            "Livraison en 12 mois au lieu de 18",
            "1 M€ d'économies",
            "1ère mise en service d'une fonction réseau critique virtualisée",
            "Architecture devenue référence Groupe",
          ],
          metric: { value: "12 mois", label: "vs 18 prévus" },
        },
        {
          tag: "Réseaux Afrique",
          title: "Concevoir et piloter la modernisation des réseaux télécoms en Afrique",
          context:
            "Plusieurs filiales Orange en Afrique devaient moderniser leurs réseaux pour accompagner la croissance data, la 4G, la fibre et l'amélioration de l'expérience client.",
          countries: ["Égypte", "Côte d'Ivoire", "Cameroun", "Sierra Leone"],
          actions: [
            "Stratégies réseaux par pays",
            "Architecture bout-en-bout",
            "Sourcing fournisseurs",
            "Études technico-économiques",
            "Coordination Groupe / pays / fournisseurs",
            "Montée en compétences locales",
          ],
          results: [
            "Réseaux modernisés",
            "Architectures de référence",
            "Expérience client améliorée",
            "Coûts réduits",
            "Déploiements 4G et fibre accompagnés",
            "Transfert de compétences aux équipes locales",
          ],
          metric: { value: "4 pays", label: "filiales Orange accompagnées" },
        },
      ],
    },
    method: {
      overline: "Méthodologie",
      title: "Une méthode simple : comprendre, structurer, exécuter, pérenniser.",
      stepWord: "Étape",
      steps: [
        { title: "Diagnostiquer", desc: "Comprendre les enjeux, les acteurs, les contraintes, les priorités et les risques." },
        { title: "Structurer", desc: "Définir une trajectoire claire, une gouvernance, des responsabilités et une feuille de route." },
        { title: "Aligner", desc: "Fédérer les parties prenantes autour d'objectifs communs et mesurables." },
        { title: "Exécuter", desc: "Piloter les actions, mesurer l'avancement, arbitrer les priorités et sécuriser les résultats." },
        { title: "Transférer", desc: "Renforcer les équipes locales pour garantir l'autonomie et la durabilité." },
      ],
    },
    figures: {
      overline: "Chiffres clés",
      title: "L'impact en chiffres.",
      list: [
        { value: 17, suffix: "+", label: "ans d'expérience" },
        { value: 300, suffix: "M€+", label: "programme IRIS²" },
        { value: 2, suffix: "M€", label: "économies cloud" },
        { value: 3, prefix: "x", label: "capacité de livraison cyber" },
        { value: 1, suffix: "M€", label: "économies Telco Cloud" },
        { value: 10, suffix: "+", label: "pays accompagnés" },
        { value: 20, suffix: "+", label: "programmes stratégiques" },
        { value: 5, suffix: "+", label: "domaines d'expertise" },
      ],
    },
    insights: {
      overline: "Insights",
      title: "Analyses et retours d'expérience.",
      paragraph: "Des points de vue concrets sur la transformation digitale, les télécoms, le cloud souverain et le pilotage de programmes complexes.",
      readMore: "Lire l'article",
      viewAll: "Voir tous les insights",
      backToList: "Retour aux insights",
      backToHome: "Retour à l'accueil",
      minRead: "min de lecture",
      relatedTitle: "À lire également",
      notFoundTitle: "Article introuvable",
      notFoundDesc: "Cet article n'existe pas ou a été déplacé.",
      listPageTitle: "Insights — Birrou Advisory & Consulting",
      listPageHeading: "Insights",
      listPageSubheading: "Analyses, retours d'expérience et méthodes éprouvées sur la transformation digitale, les télécoms, le cloud souverain et le pilotage de programmes complexes.",
    },
    about: {
      overline: "À propos",
      name: "Mamadou Birrou Diallo",
      role: "Directeur de programmes stratégiques",
      p1: "Directeur de programmes stratégiques, spécialisé dans la transformation digitale, les télécommunications, le cloud souverain, la cybersécurité et la gouvernance de programmes complexes.",
      p2: "Avec plus de 17 ans d'expérience au sein du Groupe Orange, il a piloté des transformations majeures en Europe, en Afrique et au Moyen-Orient, en connectant stratégie, technologie, business et opérations.",
      p3: "Son moteur : produire des résultats concrets, utiles et durables.",
      badgeCompanies: "Orange • Orange Cyberdéfense • Orange Innovation",
      badgeRegions: "Europe • Afrique • Moyen-Orient",
      linkedinCta: "Voir le profil LinkedIn complet",
    },
    testimonials: {
      overline: "Témoignages",
      title: "Des collaborations marquantes.",
      list: [
        {
          quote:
            "Birrou a une capacité remarquable à aligner les acteurs et à les faire avancer ensemble dans des contextes complexes.",
          author: "Directeur de programme",
          company: "Groupe Orange",
        },
        {
          quote: "Sa capacité à apaiser les tensions et faire avancer le collectif a été déterminante.",
          author: "Sponsor exécutif",
          company: "Programme stratégique",
        },
        {
          quote: "Il sait poser les bonnes questions, challenger avec bienveillance et donner du sens aux décisions.",
          author: "Membre de comité de pilotage",
          company: "Transformation cloud",
        },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Vous avez une transformation stratégique à structurer ou accélérer ?",
      paragraph:
        "Discutons de vos enjeux, de vos priorités et de la meilleure manière de transformer votre ambition en résultats concrets.",
      whatsappTitle: "Planifier un échange (WhatsApp)",
      linkedinTitle: "Profil LinkedIn",
      emailTitle: "Email direct",
      form: {
        name: "Nom complet",
        namePh: "Jean Dupont",
        email: "Email",
        emailPh: "jean@organisation.com",
        organization: "Organisation",
        organizationPh: "Ministère, opérateur, entreprise…",
        subject: "Sujet",
        subjectPh: "Stratégie télécom, cloud souverain…",
        message: "Message",
        messagePh: "Décrivez votre contexte, vos enjeux et vos priorités…",
        replyDelay: "Réponse sous 24-48h ouvrées",
        submit: "Envoyer le message",
        sending: "Envoi en cours…",
      },
      success: {
        title: "Message envoyé",
        desc: "Merci. Vous recevrez une réponse rapidement.",
        again: "Envoyer un nouveau message",
      },
      toasts: {
        success: "Message envoyé. Merci !",
        error: "Une erreur est survenue. Réessayez.",
      },
    },
    footer: {
      tagline:
        "Aider les organisations à transformer leurs ambitions stratégiques en résultats concrets.",
      navHeading: "Navigation",
      contactHeading: "Contact",
      rights: "Tous droits réservés.",
    },
  },

  en: {
    nav: {
      brandSub: "& Consulting",
      expertises: "Expertise",
      references: "Case Studies",
      method: "Method",
      insights: "Insights",
      about: "About",
      contact: "Contact",
      cta: "Book a meeting",
      menu: "Menu",
    },
    hero: {
      badge: "Vision • Strategy • Transformation • Execution",
      titleA: "Aligning Vision, Transformation and Execution to ",
      titleHighlight: "create value",
      titleEnd: ".",
      subtitle:
        "Birrou Advisory & Consulting supports governments, institutions, operators and enterprises in their strategic projects, their organizational and technological transformations, and in steering complex initiatives that create lasting value.",
      micro:
        "17+ years of experience on strategic programs at Orange, Orange Cyberdefense and Orange Innovation — Europe, Africa and the Middle East.",
      ctaWhatsapp: "Book a meeting",
      ctaExpertises: "Discover my expertise",
      ctaLinkedin: "View LinkedIn profile",
      proofs: [
        { value: "17+", label: "years of experience" },
        { value: "x3", label: "delivery capacity" },
        { value: "€2M", label: "cloud savings" },
        { value: "€300M+", label: "IRIS² program" },
        { value: "", label: "Europe • Africa • MENA" },
      ],
    },
    value: {
      overline: "Value proposition",
      title: "Strategic expertise rooted in execution.",
      paragraph:
        "In complex transformations, the challenge is not just defining a vision. The real issue is aligning stakeholders, prioritizing actions, driving execution and delivering measurable results.",
      quote:
        "“I don't come with ready-made solutions. I start by understanding the stakes, the constraints and the priorities, then co-build a realistic, viable and executable trajectory.”",
      dimensions: [
        { title: "Strategy", desc: "Define a clear vision, readable priorities and sustainable trade-offs." },
        { title: "Transformation", desc: "Align stakeholders, structure governance and orchestrate change." },
        { title: "Technology", desc: "Architect modern, sovereign and sustainable solutions." },
        { title: "Execution", desc: "Drive delivery, measure value, secure results." },
      ],
    },
    expertises: {
      overline: "Expertise",
      title: "Five domains, one demand: transform for good.",
      paragraph:
        "Complementary expertise to structure, modernize and steer your transformations in complex, multi-stakeholder environments.",
      blocks: [
        {
          title: "Digital strategy & governance",
          items: [
            "National digital strategy",
            "Multi-stakeholder governance",
            "Strategic PMO",
            "Organizational transformation",
            "Interoperability",
            "Rationalization of digital initiatives",
          ],
        },
        {
          title: "Telecommunications & infrastructure",
          items: [
            "National telecom strategy",
            "Network modernization",
            "4G / 5G / fiber",
            "PPP models",
            "Infrastructure monetization",
            "Digital inclusion",
          ],
        },
        {
          title: "Sovereign cloud & cybersecurity",
          items: [
            "Cloud governance",
            "Sovereign cloud",
            "FinOps",
            "Cloud SOC",
            "DevSecOps",
            "Security-by-design",
          ],
        },
        {
          title: "IT transformation & operations",
          items: [
            "IT rationalization",
            "Lean-Agile",
            "Project governance",
            "Automation",
            "Deployment industrialization",
            "Delivery capacity",
          ],
        },
        {
          title: "Innovation, AI & unified solutions",
          items: [
            "Product as a Service",
            "Unified platforms",
            "AI marketplace",
            "Intelligent automation",
            "Sovereign solutions",
            "Use-case transformation",
          ],
        },
      ],
    },
    cases: {
      overline: "Case studies",
      title: "Strong references in complex environments.",
      labels: { context: "Context", actions: "Actions", results: "Results" },
      list: [
        {
          tag: "Orange Cyberdefense",
          title: "Accelerating cybersecurity service delivery in a high-growth environment",
          context:
            "Strong business growth, shifting priorities, team mergers, limited resources and high security requirements.",
          actions: [
            "Business / IT / operations alignment",
            "Lean-Agile governance",
            "Backlog prioritization",
            "Deployment industrialization",
            "Process simplification",
          ],
          results: [
            "Delivery capacity multiplied by 3",
            "From 2 to 6 projects delivered in 3 months",
            "Higher customer satisfaction",
            "Reduced team pressure",
          ],
          metric: { value: "x3", label: "delivery capacity" },
        },
        {
          tag: "IRIS²",
          title: "Driving sovereign bids in a strategic European space program",
          context:
            "European sovereign and secure communications program, multi-partner environment, cooperation / competition dynamics.",
          actions: [
            "Lead two strategic lots",
            "Coordinate 5 work packages",
            "Technical, financial, contractual & security offers",
            "Supplier challenge",
            "Cost / risk / performance optimization",
          ],
          results: [
            "Full bid delivered on time",
            "Consortium congratulations",
            "Strengthened Orange credibility",
            "Improved technical and financial competitiveness",
          ],
          metric: { value: "€300M+", label: "strategic program" },
        },
        {
          tag: "Cloud Operations",
          title: "Structuring a secure, efficient and profitable cloud operating model",
          context:
            "Orange Innovation cloudification, security, cost, sovereignty and multi-entity governance challenges.",
          actions: [
            "Cross-cutting cloud governance",
            "FinOps implementation",
            "Cloud SOC deployment",
            "Hyperscaler coordination",
            "Usage rationalization",
          ],
          results: [
            "€2M savings on €18M cloud spend",
            "88 security rules monitored",
            "Improved financial visibility",
            "Strengthened cloud governance",
          ],
          metric: { value: "€2M", label: "cloud savings" },
        },
        {
          tag: "Telco Cloud — European subsidiary",
          title: "Accelerating a European Orange subsidiary's Telco Cloud transformation",
          context:
            "Strategic transformation toward virtualization, automation and 5G readiness.",
          actions: [
            "Country / Group team alignment",
            "Technical trade-off steering",
            "Supplier coordination",
            "End-to-end WAN/CNF architecture",
            "Steering committee facilitation",
          ],
          results: [
            "Delivery in 12 months instead of 18",
            "€1M savings",
            "First go-live of a virtualized critical network function",
            "Architecture became Group reference",
          ],
          metric: { value: "12 months", label: "vs 18 planned" },
        },
        {
          tag: "Africa Networks",
          title: "Designing and steering the modernization of African telecom networks",
          context:
            "Several Orange subsidiaries in Africa had to modernize their networks to support data growth, 4G, fiber and customer experience.",
          countries: ["Egypt", "Côte d'Ivoire", "Cameroon", "Sierra Leone"],
          actions: [
            "Per-country network strategies",
            "End-to-end architecture",
            "Supplier sourcing",
            "Techno-economic studies",
            "Group / country / supplier coordination",
            "Local upskilling",
          ],
          results: [
            "Modernized networks",
            "Reference architectures",
            "Improved customer experience",
            "Reduced costs",
            "4G and fiber roll-outs supported",
            "Skills transfer to local teams",
          ],
          metric: { value: "4 countries", label: "Orange subsidiaries" },
        },
      ],
    },
    method: {
      overline: "Methodology",
      title: "A simple method: understand, structure, execute, sustain.",
      stepWord: "Step",
      steps: [
        { title: "Diagnose", desc: "Understand the stakes, stakeholders, constraints, priorities and risks." },
        { title: "Structure", desc: "Define a clear trajectory, governance, responsibilities and roadmap." },
        { title: "Align", desc: "Bring stakeholders together around shared, measurable objectives." },
        { title: "Execute", desc: "Drive actions, measure progress, arbitrate priorities and secure results." },
        { title: "Transfer", desc: "Strengthen local teams to ensure autonomy and sustainability." },
      ],
    },
    figures: {
      overline: "Key figures",
      title: "Impact in numbers.",
      list: [
        { value: 17, suffix: "+", label: "years of experience" },
        { value: 300, suffix: "M€+", label: "IRIS² program" },
        { value: 2, suffix: "M€", label: "cloud savings" },
        { value: 3, prefix: "x", label: "cyber delivery capacity" },
        { value: 1, suffix: "M€", label: "Telco Cloud savings" },
        { value: 10, suffix: "+", label: "countries supported" },
        { value: 20, suffix: "+", label: "strategic programs" },
        { value: 5, suffix: "+", label: "areas of expertise" },
      ],
    },
    insights: {
      overline: "Insights",
      title: "Analyses and field lessons.",
      paragraph: "Concrete viewpoints on digital transformation, telecoms, sovereign cloud and complex program management.",
      readMore: "Read article",
      viewAll: "View all insights",
      backToList: "Back to insights",
      backToHome: "Back to home",
      minRead: "min read",
      relatedTitle: "Also worth reading",
      notFoundTitle: "Article not found",
      notFoundDesc: "This article doesn't exist or has been moved.",
      listPageTitle: "Insights — Birrou Advisory & Consulting",
      listPageHeading: "Insights",
      listPageSubheading: "Analyses, field lessons and proven methods on digital transformation, telecoms, sovereign cloud and complex program management.",
    },
    about: {
      overline: "About",
      name: "Mamadou Birrou Diallo",
      role: "Strategic Programs Director",
      p1: "Strategic programs director, specialized in digital transformation, telecommunications, sovereign cloud, cybersecurity and complex program governance.",
      p2: "With more than 17 years of experience within the Orange Group, he has led major transformations across Europe, Africa and the Middle East, connecting strategy, technology, business and operations.",
      p3: "His drive: deliver concrete, useful and lasting results.",
      badgeCompanies: "Orange • Orange Cyberdefense • Orange Innovation",
      badgeRegions: "Europe • Africa • Middle East",
      linkedinCta: "View full LinkedIn profile",
    },
    testimonials: {
      overline: "Testimonials",
      title: "Defining collaborations.",
      list: [
        {
          quote:
            "Birrou has a remarkable ability to align stakeholders and move them forward together in complex contexts.",
          author: "Program Director",
          company: "Orange Group",
        },
        {
          quote: "His ability to ease tensions and move the collective forward has been decisive.",
          author: "Executive Sponsor",
          company: "Strategic Program",
        },
        {
          quote: "He knows how to ask the right questions, challenge with care, and bring meaning to decisions.",
          author: "Steering Committee Member",
          company: "Cloud Transformation",
        },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Have a strategic transformation to structure or accelerate?",
      paragraph:
        "Let's discuss your stakes, priorities and the best way to turn your ambition into concrete results.",
      whatsappTitle: "Schedule a call (WhatsApp)",
      linkedinTitle: "LinkedIn profile",
      emailTitle: "Direct email",
      form: {
        name: "Full name",
        namePh: "John Doe",
        email: "Email",
        emailPh: "john@organization.com",
        organization: "Organization",
        organizationPh: "Ministry, operator, enterprise…",
        subject: "Subject",
        subjectPh: "Telecom strategy, sovereign cloud…",
        message: "Message",
        messagePh: "Describe your context, stakes and priorities…",
        replyDelay: "Reply within 24-48 business hours",
        submit: "Send message",
        sending: "Sending…",
      },
      success: {
        title: "Message sent",
        desc: "Thank you. You will receive a reply shortly.",
        again: "Send another message",
      },
      toasts: {
        success: "Message sent. Thank you!",
        error: "An error occurred. Please try again.",
      },
    },
    footer: {
      tagline:
        "Helping organizations turn strategic ambitions into concrete results.",
      navHeading: "Navigation",
      contactHeading: "Contact",
      rights: "All rights reserved.",
    },
  },
};
